module.exports = __webpack_public_path__ + "static/media/feature_realtime_dashboard.cd42656e.png";